export default __webpack_public_path__ + "static/media/7.1dae4f0c.jpg";